type QueryParams = {
  [key: string]: string
}

const addQueryParams = (baseUrl: string, queryParams: QueryParams): string => {
  const url = new URL(baseUrl)

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value) {
      url.searchParams.append(key, String(value))
    }
  })

  return url.toString()
}

export { addQueryParams, type QueryParams }
